module.exports = __webpack_public_path__ + "img/gard_horizontal_4.ed86085e.png";